module.exports = __webpack_public_path__ + "sgby/img/zhugeliang-pic.c35d224.png";